import { c as _c } from "react/compiler-runtime";
import { isEmail } from '@onefootprint/core';
import { Button, TextInput } from '@onefootprint/ui';
import { useForm } from 'react-hook-form';
export type EmailFormData = {
  email: string;
};
export type EmailFormProps = {
  defaultEmail?: string;
  isLoading?: boolean;
  onSubmit: (formData: EmailFormData) => void;
  texts: {
    cta: string;
    email: {
      invalid: string;
      label: string;
      placeholder: string;
      required: string;
    };
  };
};
const EmailForm = t0 => {
  const $ = _c(27);
  const {
    defaultEmail,
    isLoading,
    onSubmit,
    texts
  } = t0;
  let t1;
  if ($[0] !== defaultEmail) {
    t1 = {
      defaultValues: {
        email: defaultEmail
      }
    };
    $[0] = defaultEmail;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    register,
    handleSubmit,
    getValues,
    formState: t2
  } = useForm(t1);
  const {
    errors
  } = t2;
  const hasError = !!errors.email;
  const hint = hasError ? errors.email?.message : undefined;
  let t3;
  if ($[2] !== handleSubmit || $[3] !== onSubmit) {
    t3 = handleSubmit(onSubmit);
    $[2] = handleSubmit;
    $[3] = onSubmit;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== getValues) {
    t4 = getValues("email");
    $[5] = getValues;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const t5 = texts.email.label;
  const t6 = texts.email.placeholder;
  let t7;
  if ($[7] !== register || $[8] !== texts.email.invalid || $[9] !== texts.email.required) {
    let t8;
    if ($[11] !== texts.email.invalid) {
      t8 = value => {
        if (!isEmail(value)) {
          return texts.email.invalid;
        }
        return true;
      };
      $[11] = texts.email.invalid;
      $[12] = t8;
    } else {
      t8 = $[12];
    }
    t7 = register("email", {
      required: {
        value: true,
        message: texts.email.required
      },
      validate: t8
    });
    $[7] = register;
    $[8] = texts.email.invalid;
    $[9] = texts.email.required;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[13] !== hasError || $[14] !== hint || $[15] !== t4 || $[16] !== t7 || $[17] !== texts.email.label || $[18] !== texts.email.placeholder) {
    t8 = <div className="mb-6 mt-4"><TextInput autoFocus={true} data-dd-privacy="mask" data-nid-target="email" defaultValue={t4} hasError={hasError} hint={hint} label={t5} placeholder={t6} type="email" {...t7} /></div>;
    $[13] = hasError;
    $[14] = hint;
    $[15] = t4;
    $[16] = t7;
    $[17] = texts.email.label;
    $[18] = texts.email.placeholder;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== isLoading || $[21] !== texts.cta) {
    t9 = <div className="mb-4"><Button fullWidth={true} loading={isLoading} type="submit" size="large" data-dd-action-name="email:continue">{texts.cta}</Button></div>;
    $[20] = isLoading;
    $[21] = texts.cta;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  let t10;
  if ($[23] !== t3 || $[24] !== t8 || $[25] !== t9) {
    t10 = <form onSubmit={t3}>{t8}{t9}</form>;
    $[23] = t3;
    $[24] = t8;
    $[25] = t9;
    $[26] = t10;
  } else {
    t10 = $[26];
  }
  return t10;
};
export default EmailForm;